const en = {
  translation: {
    //home
    home: "Home",
    vehicles: "Vehicles",
    sign_in: "Sign in",
    plan_you_trip: "Plan your trip now",
    save_big: "Save big with our affordable car rental!",
    with_our_car: "with our affordable car rental!",
    save_big_desc:
      "Rent the car of your dreams. Unbeatable prices, unlimited miles, flexible pick-up options and much more.",
    book_ride: "Book Ride",
    learn_more: "Learn More",
    book_a_car: "Book a car",
    without_driver: "Without Driver",
    with_driver: "With Driver",
    select_booking_type: "Select Booking Type",
    self_drive: "Self Drive",
    tour: "Tour / Daily Charter",
    transfer_service: "Transfer Service",
    pickup_date: "Pick-up date",
    dropoff_date: "Drop-off date",
    pickup_location: "Pick-up location",
    dropoff_location: "Drop-off location",
    book_now: "Book Now",
    the_price_exclude: "The price excludes the driver’s fee, which will be additional charge",
    select_tour_package: "Select Tour Package",
    select_duration: "Select Duration",
    destination_location: "Destination location",
    quick_and_easy: "Quick & easy car rental",
    select_car: "Select Car",
    we_offer:
      "We offers a big range of vehicles for all your driving needs. We have the perfect car to meet your needs",
    contact_operator: "Contact Operator",
    our_knowlage: "Our knowledgeable and friendly operators are always ready to help with any questions or concerns",
    let_drive: "Let's Drive",
    whether_you: "Whether you're hitting the open road, we've got you covered with our wide range of cars",
    vehicle_models: "Vehicle Models",
    our_rental_fleet: "Our rental fleet",
    choose_from: "Choose from a variety of our amazing vehicles to rent for your next adventure or business trip",
    reserve_now: "RESERVE NOW",
    save_big_bottom: "Save big with our cheap car rental!",
    top_airport: "Top Airports. Local Suppliers. ",
    support: "support",
    why_choose_use: "Why Choose Us",
    best_valued: "Best valued deals you will ever find",
    discover_the_best:
      "Discover the best deals you'll ever find with our unbeatable offers. We're dedicated to providing you with the best value for your money, so you can enjoy top-quality services and products without breaking the bank. Our deals are designed to give you the ultimate renting experience, so don't miss out on your chance to save big.",
    find_details: "Find details",
    cross_city: "Cross City Drive",
    take_your_driving:
      "Take your driving experience to the next level with our top-notch vehicles for your cross-country adventures.",
    all_inclusive: "All Inclusive Pricing",
    get_everything:
      "Get everything you need in one convenient, transparent price with our all-inclusive pricing policy.",
    no_hidden: "No Hidden Charges",
    enjoy_peace: "Enjoy peace of mind with our no hidden charges policy. We believe in transparent and honest pricing.",
    review_by_people: "Reviewed by People",
    client_testimonial: "Client's Testimonials",
    client_testimonial_desc:
      "Discover the positive impact we've made on the our clients by reading through their testimonials. Our clients have experienced our service and results, and they're eager to share their positive experiences with you.",
    testi_aris:
      "I really like it. The service is as cool as the driver arrives on time and knows the way. Very happy, the service is really cool. The car too. Smells clean and everything goes smoothly. Make Mas Yoyok (driver) successful and healthy, then yeah... For a rental car entrepreneur, I dont want to say anything else. Because there were no complaints. Anyway, success.",
    testi_solomon:
      "I rented an Avanza, 2016 type G. The vehicle had no problems, the engine was smooth, the vehicle body was neatly registered, and most importantly when you rented the vehicle, the WA team/group was immediately prepared... for the requested documents... that's cool. the main thing is.",
    faq: "FAQ",
    frequently_asked: "Frequently Asked Questions",
    frequently_asked_desc:
      "Frequently Asked Questions About the Car Rental Booking Process on Our Website: Answers to Common Concerns and Inquiries.",
    what_is_special: "1. What is special about comparing rental car deals?",
    what_is_special_desc:
      " Comparing rental car deals is important as it helps find the best deal that fits your budget and requirements, ensuring you get the most value for your money. By comparing various options, you can find deals that offer lower prices, additional services, or better car models. You can find car rental deals by researching online and comparing prices from different rental companies.",
    how_do_2: "2. How do I find the car rental deals?",
    how_do_2_desc:
      "You can find car rental deals by researching online and comparing prices from different rental companies. Websites such as Expedia, Kayak, and Travelocity allow you to compare prices and view available rental options. It is also recommended to sign up for email newsletters and follow rental car companies on social media to be informed of any special deals or promotions.",
    how_do_3: "3. How do I find such low rental car prices?",
    how_do_3_desc:
      "Book in advance: Booking your rental car ahead of time can often result in lower prices. Compare prices from multiple companies: Use websites like Kayak, Expedia, or Travelocity to compare prices from multiple rental car companies. Look for discount codes and coupons: Search for discount codes and coupons that you can use to lower the rental price. Renting from an off-airport location can sometimes result in lower prices.",
    reservation_12: "Reservations must be made at least 12 hours in advance",
    reservation_24: "Reservations must be made at least 24 hours in advance",
    drop_after_pickup: "Drop-off date must be after pickup date",
    //car card
    daily_rate_from: "Daily rate from",
    includes: "Includes",
    isurances_etc: "INSURANCES,CUSTOMER SERVICE",
    more_info: "More Info",
    efficient: "Efficient",
    safe: "Safe",
    economical: "Save",
    //select vehicle
    book_car_by_getting: "Book a car by getting in touch with us",
    select_vehicle: "Select Vehicle",
    complete_reservation: "COMPLETE RESERVATION",
    upon_completing: "Upon completing this reservation enquiry, you will receive:",
    your_rent_voucher:
      "Your rental voucher to produce on arrival at the rental desk and a toll-free customer support number.",
    location_n_date: "Location & Date",
    car: "Car",
    pickup_date_n_time: "Pick-Up Date & Time",
    dropoff_date_n_time: "Drop-off Date & Time",
    prices: "Prices",
    additional_items: "Additional Items",
    umbrella: "Umbrella",
    baby_seat: "Baby Seat",
    insurance: "Insurance",
    full_covered: "Full Covered Insurance",
    wedding: "Wedding Car",
    flower_arrangement: "Flower Arrangement (Wedding Car)",
    additional_stop: "Additional Stop",
    flower_bouquet: "Flower Bouquet",
    all_in_one_for: "Toll and parking",
    price_estimate: "Price Estimate",
    estimate_total: "Estimate total",
    the_price_does_not: "The price does not include toll fee, parking fee, gratuitty.",
    the_price_includes: "The price includes petrol and one way parking",
    personal_info: "PERSONAL INFORMATION",
    identity_type: "Identity type",
    select_identity: "Select Identity",
    identity_image: "Identity image",
    choose_file: "Choose file",
    sim_or: "SIM / Driving License",
    name: "Name",
    booker_name: "Booker name",
    enter_name: "Enter your name",
    enter_booker_name: "Enter booker name",
    whatsapp_number: "Whatsapp Number",
    enter_whatsapp_number: "Enter your whatsapp number",
    email: "Email",
    enter_email: "Enter your email address",
    address: "Address",
    enter_address: "Enter your address",
    emergency_contact_1: "Emergency contact 1",
    emergency_contact_2: "Emergency contact 2",
    enter_emergency: "Enter your emergency contact",
    return_flight: "Return Flight Reservation",
    hotel_accomodation: "Hotel/Accommodation During Your Stays",
    notes: "Notes",
    enter_notes: "Enter your notes",
    we_will_ask: "We will ask for additional data if needed.",
    rental_policy: "Rental Policy",
    in_town_usage: "In-town usage",
    add_outside_island: "Add outside island usage",
    outside_island_usage: "Outside Island Usage",
    for_self_drive: "Outside Island Usage For Self Drive",
    denpasar_jimbaran_etc: "Denpasar, Jimbaran, Legian, Nusa Dua, Uluwatu, Ubud Center, Seminyak.",
    out_of_town_usage: "Out-of-town usage",
    zone_1: "Zone 1",
    zone_2: "Zone 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (fee depends on car type)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (fee depends on car type)",
    this_rate_valid: "This rate valid for one direction only.",
    add_out_off_town: "Add out-of-town usage",
    select_date: "Select Date",
    select_travel_date: "Select a travel date outside the city",
    select_travel_date_island: "Select a travel date outside the island",
    total: "Total",
    close: "Close",
    add: "Add",
    loading: "Loading...",
    //customer form
    additional_information: "Additional Information (Optional)",
    guest_name: "Guest Name",
    driver_name: "Driver Name",
    passanger_total: "Passanger Total",
    luggage_total: "Luggage Total",
    flight_detail: "Flight Detail",
    airline_name: "example: airline name: Garuda, arrival time: 17.00",
    hotel_detail: "Hotel/Accommodation Detail",
    hotel_name: "example: hotel name: indah hotel",
    disability_needs: "Disability Needs",
    wheelchair: "example: wheelchair : 1",
    the_price_varies: "The price varies depending on the destination location.",
    including_petrol: "Including toll and parking",
    change: "Change",
    setting_date_use: "Setting the date of use",
    date: "Date",

    //detail vehicle
    detail_vehicle: "Detail Vehicle",
    price_type: "Price Type",
    price: "Price",
    area: "Area",
    yes: "Yes",
    trunk: "Trunk",
    customer_service: "CUSTOMER SERVICE",
    insurances: "INSURANCES",
    with_a_professional:
      "With a professional and extensive after-sales service, you can rest easy because of the good support from our team. You can  also take advantage of various attractive offers and special promos when ordering this car.",
    select_this_car: "Select this car",
    //global
    save: "Save",
    big: "big",
    days: "Days",
    hour: "Hour",
    brand: "Brand",
    year: "Year",
    seat: "Seat",
    ac: "AC",
    transmission: "Transmission",
    fuel: "Fuel",
    color: "Color",
    company: "Company",
    working_hour: "Working Hour",
    //privacy and policy
    privacy_and_police: "Terms and Conditions",
    for_overtime:
      "For Overtime, an additional fee of Rp 50,000 / hour will be charged (Overtime exceeding 2 hours will be counted as 1 day of usage).",
    for_extension:
      "For extending the rental unit more than 2 times, please verify and confirm at our office, Wirasana Rent A Car Denpasar, Jl. Bypass Ngurah Rai No.162, Sanur Kaja, South Denpasar.",
    unit_vehicles:
      "Rental vehicle units cannot be transferred/used by anyone other than the renter who signed the rental contract (If the car is used as evidence, a daily rental fee will be charged).",
    reschedule_or:
      "Rescheduling or changing the location of unit pickup/drop-off cannot be confirmed if the notice is less than 1x24 hours according to the booking schedule, to avoid operational setting errors.",
    reschedule_date:
      "For rescheduling the date or time of unit pickup/drop-off, there is a fee of Rp 75,000 (maximum 2 reschedules allowed).",
    for_lose_umbrella:
      "For the loss of an umbrella during the rental period, a fee of Rp 100,000 per umbrella will be charged.",
    for_lose_baby_seat:
      "For the loss of a Baby Car Seat during the rental period, a fee of Rp 2,000,000 per Baby Car Seat will be charged.",
    usage_unit: "Unit usage is only for the Bali area.",
    lose_stnk: "For the loss of STNK (vehicle registration) there is a fee of Rp 1,500,000.",
    lose_plat: "For the loss of license plates, there is a fee of Rp 250,000.",
    for_damage_ban:
      "For tire damage due to improper use/use other than asphalt roads, a fee of Rp 700,000 per tire will be charged.",
    for_beret: "If there are new scratches, a fee of Rp 750,000 per incident will be charged.",
    towing_fee: "Towing car fees, and rental car fees during repairs are not included in the own risk charge.",
    lack_of_petrol: "A shortage of fuel during pickup or drop-off will incur a fee of Rp 100,000 per box.",
    fuel_in_the_middle:
      "If you encounter a lack of fuel in the middle of the journey, there will be a handling fee of Rp 250,000 for areas within the city.",
    smell:
      "If there is a smell of durian/vomit/cigarettes/wet car seats during the return of the car, there will be a fee of Rp. 1,500,000.",
    dirty_car: "For a car returned in very dirty condition, there is a cleaning fee of Rp. 150,000.",
    lost_the_key: "For the loss of car keys, a fee of Rp. 1,500,000 will be charged.",
    more_than_one_driver: "If there are more than one driver, a fee of Rp. 50,000/ID/day will be charged.",
    please_not_park:
      "Please do not park the vehicle under trees or in locations that may endanger the position of the vehicle.",
    charging_error: "In case of a fuel filling error, there will be a repair fee of Rp 2,500,000.",
    not_info:
      "If we do not receive information related to the need for vehicle repair assistance during the rental, we will not accept reimbursement from any workshop without approval/discussion.",
    trouble_car:
      "If there is a problem with the vehicle, our mechanics will try to follow up and assist you within a maximum of 4 hours (depending on your location at that time).",
    security_deposit:
      "A Security Deposit of Rp 500,000 will be kept as a guarantee during the rental period (Security deposit will be refunded via bank transfer within a maximum of 7 days after the vehicle is returned and after E-Tilang check).",
    basic_usage: "Basic usage is limited to within the city as per Traveloka's map.",
    excess_usage:
      "Excess usage beyond 12 hours or after midnight will incur additional charges as per Traveloka's appendix/rules.",
    driver_contact: "The driver will contact you when they are about to arrive at the pickup location.",
    other_questions: "If you have any other questions, feel free to contact us.",
    pickup_point:
      "Pick-up point is in front of Solaria, if you wish to request a different pick-up point, please inform us directly through this group.",
    reschedule_info:
      "Rescheduling or changes to pick-up and destination locations cannot be confirmed if the notification is less than 24 hours prior to the scheduled booking, to avoid operational setup errors.",
    reschedule_fee: "There is a rescheduling fee of IDR 75,000 (maximum of 2 reschedules).",
    reschedule_airline:
      "For reschedules due to airline changes, please attach proof of the reschedule, and we will confirm it without a rescheduling fee. However, the type of vehicle for pick-up will depend on vehicle availability at the rescheduled time.",
    airline_delay:
      "In case of airline delays, please provide proof of the delay. Our driver will make every effort to pick you up according to the latest schedule.",
    voucher_usage: "The voucher is valid for a one-time pick-up without stops or one-way drop only.",
    additional_stop_meals: "Additional stops for meals, etc. will incur an additional charge of IDR 100,000 per hour.",
    driver_wait_time:
      "The driver will wait for up to 30 minutes. If it exceeds the specified time, there will be an additional charge of IDR 100,000 per hour.",
    destination_change: "There will be an additional charge for destination changes based on the location.",
    no_eating_drinking: "Eating and drinking that may cause spills in the vehicle is not allowed.",
    boarding_landing: "Please confirm once you have boarded and landed at Ngurah Rai Airport.",
    driver_details: "Driver details will be provided on the day of the trip.",
    mask_and_distance: "Please always wear a mask and maintain social distancing inside the vehicle.",
    disinfected_vehicles: "All Wirasana vehicles have been disinfected beforehand.",
    SWAB_driver_charge: "Additional charge for SWAB driver is IDR 99,000 (if required).",
    passenger: "Passenger",
    use_the_current_location: "Use the current location",
    cancel: "Cancel",
    confirm: "Confirm",
    i_have_read_and_accept: "I have read and accept the Privacy Policy",
    i_accept_the_privacy: "I accept the Privacy Policy",
    open_filters: " Open Filters",
    sort: "sort",
    price_low_to_high: "Price: Low to High",
    price_high_to_low: "Price: High to Low",
    name_a_z: "Name: A → Z",
    name_z_a: "Name: Z → A",
    filters: "Filters",
    price_per_day: "Price per day",
    total_passenger: "Total Passenger",
    search_car: "Search Vehicle",
    drivetrain: "Drivetrain",
    clear_all: "Clear All",
    apply_filters: "Apply Filters",
    ready_to_continue_payment: "Ready to continue payment?",
    please_review_payment: "Please review your payment details before continuing.",
    total_amount: "Total to Pay",
    proceed_to_payment: "Proceed to Payment",
    about: "About us",
    about_company: "About Company",
    about_headline: "You start the engine and your adventure begins",
    about_description:
      "Certain but she but shyness why cottage. Guy the put instrument sir entreaties affronting. Pretended exquisite see cordially the you. Weeks quiet do vexed or whose. Motionless if no to affronting imprudence no precaution. My indulged as disposal strongly attended.",
    about_car_types: "Car Types",
    about_rental_outlets: "Rental Outlets",
    about_repair_shop: "Repair Shop",
    about_book_car: "Book a car by getting in touch with us",
    about_phone: "(0361) 286-066",
    language: "Language",
    about_us: "About Us",
    contact_us: "Contact Us",
    booking_type: "Booking Type",
    the_royal_essence: "The Royal Essence of Journey",
    relaxed_journey: "RELAXED JOURNEY EVER",
    page_title: "Contact",
    headline: "Need additional information?",
    description:
      "A multifaceted professional skilled in research, development, and learning specialization. Over 15 years of experience.",
    phone_label: "Phone",
    email_label: "Email",
    address_label: "Address",
    form_name: "Full Name",
    form_message: "Tell us about it",
    form_placeholder_name: "E.g: 'Joe Shmoe'",
    form_placeholder_message: "Write here...",
    form_button: "Send via WhatsApp",
    required_alert: "Please fill in all required fields!",
    address_value: "Denpasar, Bali",
    why_choose_wirasana: "Why Choose Wirasana",
    trusted_partner: "Your Trusted Partner for Car Rental in Bali",
    experience_excellence: "Experience excellence with our premium fleet, exceptional service, and unbeatable prices.",
    happy_customers: "Happy Customers",
    vehicles_available: "Vehicles Available",
    years_experience: "Years Experience",
    satisfaction_rate: "Satisfaction Rate",
    what_makes_us_different: "What Makes Us Different",
    discover_advantages: "Discover the advantages that set us apart from the competition",
    comprehensive_insurance: "Comprehensive Insurance",
    comprehensive_insurance_desc:
      "Full coverage insurance included with every rental. Drive with peace of mind knowing you're protected.",
    premium_fleet: "Premium Fleet",
    premium_fleet_desc: "Well-maintained, modern vehicles regularly serviced to ensure the best driving experience.",
    support_247: "24/7 Support",
    support_247_desc: "Round-the-clock customer service ready to assist you whenever you need help.",
    best_price: "Best Price Guarantee",
    best_price_desc: "Competitive rates with transparent pricing. No hidden fees, no surprises.",
    flexible_rental: "Flexible Rental",
    flexible_rental_desc: "Choose your rental duration from hourly to monthly. We adapt to your schedule.",
    free_delivery: "Free Delivery",
    free_delivery_desc: "Complimentary vehicle delivery and pickup at your preferred location in Bali.",
    more_reasons: "More Reasons to Trust Us",
    trusted_by_thousands: "Trusted by Thousands",
    trusted_by_thousands_desc: "Over 10,000 satisfied customers have chosen us for their transportation needs in Bali.",
    licensed_insured: "Licensed & Insured",
    licensed_insured_desc:
      "Fully licensed and insured fleet ensuring your safety and peace of mind throughout your journey.",
    easy_booking: "Easy Booking Process",
    easy_booking_desc: "Book online in minutes with our user-friendly platform. No complicated paperwork required.",
    flexible_payment: "Flexible Payment Options",
    flexible_payment_desc:
      "Multiple payment methods accepted including credit cards, bank transfers, and digital wallets.",
    cta_title: "Ready to Start Your Journey?",
    cta_desc: "Book your perfect vehicle today and experience the Wirasana difference.",
    call_us_now: "Call Us Now",
    back: "Back",
    weather_protection: "Weather protection for outdoor activities",
    safety_seat_children: "Safety seat for children (5–4 years)",
    beautiful_flower_arrangements: "Beautiful flower arrangements for special occasions",
    extra_stops: "Extra stops during your journey",
    all_in_one_package: "All-in-one package for convenience",
    fresh_flower_bouquet: "Fresh flower bouquet arrangement",
    set_quantity_each_date: "Set quantity for each date",
    total_items: "Total items",
    items: "Items",
    select_all: "Select All",
    select_dates_apply_item: "Select the dates you want to apply this item",
    item_will_be_applied: "Item will be applied",
    out_of: "out of",
    total_day: "total day",
    type_or_choose_location: "Type a location or choose from the list...",
    select_from_map: "Select location from map",
    popular_locations: "Popular Locations",
    manual_input_hint: "Or type the location manually in the search box",
    common: {
      back: "Back",
      back_to_search: "Back to Search",
      name: "Name",
      email: "Email",
      phone: "Phone",
      total: "Total",
      hours: "Hours",
      processing: "Processing...",
      searching: "Searching...",
      error_occurred: "An error occurred. Please try again.",
      information: "Information",
    },
    booking: {
      detail: "Booking Details",
      booking_number: "Booking #{{number}}",
      not_found: "Data Not Found",
      search_again: "Please search for your booking again",
      type: "Booking Type",
      pickup_date: "Pickup Date",
      dropoff_date: "Dropoff Date",
      price_breakdown: "Price Breakdown",
      price_date: "Price ({{date}})",
      fees: "Transaction Fees & Tax",
      delivery_fee: "Delivery Fee",
      pickup_fee: "Pickup Fee",
      canceled: "Order Canceled",
      contact_customer_service: "This order has been canceled. Contact customer service for more information.",
      check_history: "Check Booking History",
      enter_details: "Enter your email and booking code to view your order details",
      booking_code: "Booking Code",
      code_example: "Example: S-0018, T-0025 (use S-0018 for demo)",
      check_booking: "CHECK BOOKING",
      info_code_sent: "Booking code is sent to your email after booking",
      info_continue_payment: "You can continue payment for unpaid orders",
      info_contact_support: "Contact customer service if you experience issues",
    },
    status: {
      booked: "Booked",
      prepared: "Prepared",
      operated: "Operated",
      canceled: "Canceled",
      success: "Success",
    },
    payment: {
      not_paid: "Not Paid",
      paid: "Paid",
      partial: "Partial Payment",
      continue: "CONTINUE PAYMENT",
      invoice_not_found: "Invoice not found",
      link_failed: "Failed to create payment link. Please try again.",
      received: "Payment Received",
      total_paid: "Total paid: {{amount}}",
    },
    validation: {
      fill_all_fields: "Please fill in email and booking code",
    },
    manage_booking: "Manage Booking",
    booking_confirmation: "Booking Confirmation",
    next: "Next",
    booking_details: "Booking Details",
    review_n_confirm: "Review & Confirm",
    booking_success: "Booking Successful!",
    booking_success_message:
      "Your booking has been successfully submitted. Please complete the payment to confirm your reservation.",
    open_payment_link: "Open Payment Link",
    required_documents: "Required Documents",
    payment_information: "Payment Information",
    review_payment_details: "Please review your payment details and proceed to payment",
    booking_summary: "Booking Summary",
    invoice_number: "Invoice Number",
    customer_name: "Customer Name",
    payment_instructions: "Payment Instructions",
    payment_instruction_1: "Click the button below to create payment invoice",
    payment_instruction_2: "You will be redirected to Xendit payment page",
    payment_instruction_3: "Complete your payment using available payment methods",
    payment_instruction_4: "You will receive confirmation email after successful payment",
    payment_link_created: "Payment link has been created!",
    click_below_to_proceed: "Click the button below to proceed to payment",
    creating_invoice: "Creating Invoice...",
    create_payment_invoice: "Create Payment Invoice",
    done: "I've completed the payment",
    order_summary: "Order Summary",
    please_review_order: "Please review your order details before proceeding to payment",
    customer_information: "Customer Information",
    phone: "Phone",
    vehicle: "Vehicle",
    rental_period: "Rental Period",
    locations: "Locations",
    price_breakdown: "Price Breakdown",
    base_price: "Base Price",
    delivery_fee: "Delivery Fee",
    pickup_fee: "Pickup Fee",
    tour_package: "Tour package prices start from",
    airport_transfer_from: "Airport transfer service prices start from",
    tourPackage: "Tour Package",
    duration: "Duration",
    basic_title: "Basic Protection",
    basic_subtitle: "Basic coverage included in your rental",
    km_unlimited: "Unlimited mileage",
    own_risk: "With own risk fee of Rp 750,000 per incident",
    damage_cover: "Coverage for collision, scratches, and impact damage",
    glass_tire: "Tire and glass protection",
    interior_protect: "Interior protection",
    not_included_towing: "Does not include towing service and additional rental days if repair lasts more than 7 days",
    got_it: "Got it",
    basic_protection: "Basic Protection",
    see_more_details: "See more details",
    insurance_protection: "Insurance Protection",
    click_to_see_details: "Click to see protection details",
    choose_insurance: "Choose Insurance Package",
    select_best_protection: "Select the package that best suits your needs",
    selected: "Selected",
    online_discount: "Online Discount",
    day: "day",
    free: "Free",
    additional_cost_per_day: "Additional cost / day",
    select_package: "Select Package",
    most_popular_choice: "Most popular choice",
    insurance_info_title: "Important Information",
    insurance_info_description:
      "We always aim to provide the best protection for our customers. We offer several insurance options that you can choose according to your needs. This insurance will serve as a reference and protection if something unfortunate happens to you.",
    confirm_selection: "Confirm Selection",
    insurance_no_extra_protection: "No Extra Protection",
    insurance_no_extra_protection_subtitle: "10% discount from Published Rate",
    insurance_no_extra_protection_desc1_en: "10% discount from Published Rate",
    insurance_no_extra_protection_desc2_en: "Unlimited mileage",
    insurance_no_extra_protection_desc3_en: "All repair costs are renter's responsibility",
    insurance_no_extra_protection_desc4_en: "No coverage for collision, scratches, or impact damage",
    insurance_no_extra_protection_desc5_en: "No tire and glass protection",
    insurance_no_extra_protection_desc6_en: "No interior protection",

    insurance_basic_protection: "Basic Protection",
    insurance_basic_protection_subtitle: "Published Rate",
    insurance_basic_protection_desc1_en: "Unlimited mileage",
    insurance_basic_protection_desc2_en: "Collision deductible fee IDR 750,000 per incident",
    insurance_basic_protection_desc3_en: "Coverage for collision, scratches, and impact damage",
    insurance_basic_protection_desc4_en: "Tire and glass protection included",
    insurance_basic_protection_desc5_en: "No interior protection",
    insurance_basic_protection_desc6_en: "Tow truck cost & rental extension above 7 days during repair not included",
    gps: "GPS",
    gps_desc: "In-car navigation system.",
    phone_holder: "Phone Holder",
    phone_holder_desc: "Hands-free phone mount for safe driving.",
    family_card: "Family Card",
    business_id: "Business Id",
    social_media: "Social Media",
    customer_info: "Customer Info",
    enter_social_media: "Enter social media",
    insurance_subtitle: "Protect your journey with comprehensive coverage and peace of mind",
    included: "Included",
    not_included: "Not Included",
    toll_and_parking: "Toll and Parking",
    toll_and_parking_desc: "Toll and parking costs",
    your_trusted_mobility: "Your Trusted Mobility Partner in Bali",
    wirasana_is_professional:
      "Wirasana Rent A Car is a professional car rental service based in Bali, dedicated to providing reliable, comfortable, and flexible transportation solutions for travelers and businesses. With years of experience in the transportation industry, we understand that mobility is an essential part of every journey — whether for leisure, business, or special occasions.",
    our_mission_is_to_make:
      "Our mission is to make transportation in Bali simple, safe, and accessible. We offer a wide range of well-maintained vehicles to suit different needs, from compact cars for personal trips to premium vehicles for business and special events.",
    lets_get_you: "Let’s Get You on the Road",
    have_questions_about:
      "Have questions about our vehicles, pricing, or availability? Our team is ready to assist you. Whether you’re planning a holiday in Bali, a business trip, or a special event, we’re here to make your transportation experience smooth and hassle-free.",
    search_vehicle: "Search Vehicle",
    vehicle_type: "Vehicle Type",
    motorcycle: "Motorcycle",
    all: "All",
    your_trustedcar_rental_in_bali: "Your Trusted Car Rental in Bali",
    simple_booking: "Simple Booking. Reliable Vehicles. Exceptional Service",
    we_provide_flexible:
      "We provide flexible rental solutions including self-drive, driver service, and airport transfers all designed to make your journey in Bali effortless.",
  },
};

export default en;
